/**
* @GasInfoDialog.vue
* @Description
* @Author JiShaoHua
* @Date 2022/10/21 16:57
**/
<template>
  <div v-if="dialogForm.dialogFormVisible">
    <el-dialog :title="dialogForm.title"
               :visible.sync="dialogForm.dialogFormVisible"
               :close-on-click-modal="false"
               :modal-append-to-body="false"
               custom-class="form-dialog"
               v-dialogDrag
               class="dialog_title"
               @close="handleDialogClose"
    >

      <el-form class="head-image-form" label-width="130px" ref="dialogRowForm" :rules="rules" :model="dialogRowForm">
        <el-form-item class="row-items-3" label="传感器类型" prop="sensorTypeId">
          <div v-if="dialogForm.optionType == optionType.edit">
            <el-input v-model="dialogRowForm.sensorType" disabled class="rt-input"/>
          </div>
          <div v-else>
            <el-select v-model="dialogRowForm.sensorTypeId" >
              <el-option
                  v-for="item in gasTypes"
                  :key="item.sensorTypeId"
                  :label="item.sensorType"
                  :value="item.sensorTypeId">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item class="row-items-3" label="传感器名称" prop="sensorName">
          <div v-if="dialogForm.optionType == optionType.edit">
            <el-input v-model="dialogRowForm.sensorName" disabled class="rt-input"/>
          </div>
          <div v-else>
            <el-input v-model="dialogRowForm.sensorName" clearable/>
          </div>
        </el-form-item>
        <el-form-item class="row-items-3" label="传感器编号" prop="deviceNo">
          <div v-if="dialogForm.optionType == optionType.edit">
            <el-input v-model="dialogRowForm.deviceNo" disabled class="rt-input"/>
          </div>
          <div v-else>
            <el-input v-model="dialogRowForm.deviceNo" clearable/>
          </div>
        </el-form-item>
        <el-form-item class="row-items-3" label="最小阈值（%）" prop="minThreshold">
            <el-input v-model="dialogRowForm.minThreshold" clearable/>
        </el-form-item>
        <el-form-item class="row-items-3" label="最大阈值（%）" prop="maxThreshold">
            <el-input v-model="dialogRowForm.maxThreshold" clearable/>
        </el-form-item>
<!--        <el-form-item class="row-items-3" label="最小量程" disabled="disabled" prop="gasMinRange">-->
<!--            <el-input v-model="dialogRowForm.gasMinRange" clearable/>-->
<!--        </el-form-item>-->
<!--        <el-form-item class="row-items-3" label="最大量程" prop="gasMaxRange">-->
<!--            <el-input v-model="dialogRowForm.gasMaxRange" clearable/>-->
<!--        </el-form-item>-->

        <el-form-item v-if="!$checkEmpty(dialogForm.submitButton)" class="row-items-1 btn-form-item-r" style="margin-bottom: 0;">
          <el-button class="el-button-bg" type="primary" size="primary" @click="submitForm()">{{dialogForm.submitButton}}</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
  </div>
  
</template>

<script>
// 公共变量
import GlobalVariable from '@/global/global-variable'
// 公共方法
import GlobalFun from '@/global/global-function'
// 传感器组件
import ApiGas from '@/request/api-gas'

export default {
  name: "GasInfoDialog",
  props: {
    gasTypes: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  /**
   * @Description 组件引用
   * @Date 9:43 2022/10/22
   * @Param
   * @Return
   */
  components: {

  },
  data() {
    return{
      // 公共变量
      GlobalVariable,
      dialogForm: {
        title: "刷卡绑定/解绑",
        submitButton: '',
        optionType: '',
        dialogFormVisible: this.visibleFlag
      },
      optionType: {
        add: 'add',
        edit: 'edit'
      },
      /**
       * @Des 修改表单
       * @Auth
       * @Date 2021/6/19
       */
      dialogRowForm: {
        // 传感器id
        sensorId: '',
        // row 下标
        rowIndex: -1,
        // 传感器类型id
        sensorTypeId: '',
        // 传感器类型
        sensorType: '',
        // 传感器名称
        sensorName: '',
        // 传感器编号
        deviceNo: '',
        // 最小阈值
        minThreshold: '',
        // 最大阈值
        maxThreshold: '',
        // 最小量程
        // gasMinRange: '',
        // 最大量程
        // gasMaxRange: '',
      },

      /**
       * @Des 弹窗规则
       * @Auth
       * @Date 2021/6/19
       */
      rules: {
        sensorType: [
          { required: true, message: '请选择传感器类型', trigger: 'false' }
        ],
        sensorName: [
          { required: true, message: '请输入传感器名称', trigger: 'blur' }
        ],
        minThreshold: [
          { required: true, message: '请输入最小阈值', trigger: 'blur' }
        ],
        maxThreshold: [
          { required: true, message: '请输入最大阈值', trigger: 'blur' }
        ],
      }// rules
    }
  },
  /**
   * @Description doc加载完成后自动执行
   * @Date 9:56 2022/10/22
   * @Param
   * @Return
   */
  mounted() {

  },
  /**
   * @Description 方法定义
   * @Date 9:56 2022/10/22
   * @Param
   * @Return
   */
  methods: {

    /**
     * @Description 打开传感器弹窗
     * @Date 9:58 2022/10/22
     * @Param
     * @Return
     */
    openDialog(title, button, optionType, data, rowIndex) {
      // console.log(data);
      this.dialogForm.dialogFormVisible = true;
      this.dialogForm.title = title;
      this.dialogForm.submitButton = button;
      this.dialogForm.optionType = optionType;

      // 重置表单
      this.reset();
      // console.log(optionType);
      if (optionType == this.optionType.add) {

      } else if(optionType == this.optionType.edit) {
        // 编辑 或 绑定
        this.$nextTick(function () {
          // 当前用户
          this.dialogRowForm.sensorId = data.sensorId;
          // row 下标
          this.dialogRowForm.rowIndex = rowIndex;
          // 名称
          this.dialogRowForm.sensorName = data.sensorName;
          // 传感器编号
          this.dialogRowForm.deviceNo = data.deviceNo;
          // 最小阈值
          this.dialogRowForm.minThreshold = data.minThreshold;
          // 最大阈值
          this.dialogRowForm.maxThreshold = data.maxThreshold;
          // 职务
          // this.dialogRowForm.gasMinRange = data.gasMinRange;
          // 备注
          // this.dialogRowForm.gasMaxRange = data.gasMaxRange;
          this.dialogRowForm.sensorType = data.sensorType;
          this.dialogRowForm.sensorTypeId = data.sensorTypeId;
        });
      }

    },
    /**
     * @Description 表单提交
     * @Date 10:12 2022/10/22
     * @Param
     * @Return
     */
    submitForm(){
      /**
       * @Des 表单校验
       * @Auth
       * @Date 2021/6/19
       */
      this.$refs.dialogRowForm.validate(valid => {
        if(!valid) return false;

        // 交互参数
        let params = {
          sensorId: this.dialogRowForm.sensorId,
          sensorTypeId: this.dialogRowForm.sensorTypeId,
          sensorType: this.dialogRowForm.sensorType,
          sensorName: this.dialogRowForm.sensorName,
          deviceNo: this.dialogRowForm.deviceNo,
          minThreshold: this.dialogRowForm.minThreshold,
          maxThreshold: this.dialogRowForm.maxThreshold
          // ,
          // gasMinRange: this.dialogRowForm.gasMinRange,
          // gasMaxRange: this.dialogRowForm.gasMaxRange
        };

        this.gasTypes.forEach((item, index) => {
          if (item.sensorTypeId == this.dialogRowForm.sensorTypeId) {
            params.sensorType = item.sensorType;
          }
        })

        // 交互 路径
        let submitApi = '';
        let successMsg = '';
        if (this.dialogForm.optionType == this.optionType.add) {
          submitApi = ApiGas.addSensorApi;
          successMsg = '添加成功！';

        } else if (this.dialogForm.optionType == this.optionType.edit) {
          submitApi = ApiGas.updateSensorApi;
          successMsg = '编辑成功！';

        }
        /**
         * @Description 数据交互
         * @Date 10:08 2022/10/22
         * @Param
         * @Return
         */
        this.$request.postJsonRequest(submitApi, params).then(result => {
          if (result.code == 0) {
            this.$message({
              message: successMsg,
              type: 'success',
              showClose: true,
              dangerouslyUseHTMLString: true
            });
            if (this.dialogForm.editFlag) {
              // 刷新列表
              this.$emit("setRow", this.dialogRowForm, this.dialogRowForm.rowIndex);
            } else {
              // 添加成功
              this.$emit("setTotal", 0);
            }

            // 编辑 关闭弹窗
            if (this.dialogForm.optionType == this.optionType.edit || this.dialogForm.optionType == this.optionType.add) {
              // 关闭弹窗
              this.dialogForm.dialogFormVisible = false;
            }

          } else {
            this.$message({
              message: result.msg,
              type: 'error',
              showClose: true,
              dangerouslyUseHTMLString: true
            });
          }

        }).catch(error => {
          console.error('操作传感器异常', submitApi, error);
        })
      });// validata
    },
    /**
     * @Description 关闭弹窗
     * @Date 10:06 2022/10/22
     * @Param
     * @Return
     */
    handleDialogClose(){
      // 重置表单
      this.reset();
    },
    /**
     * @Description 重置方法
     * @Date 10:06 2022/10/22
     * @Param
     * @Return
     */
    reset(){
      // 清除表单数据
      this.cleanData(this.dialogRowForm)
      // 清除表单验证
      this.cleanValidate('dialogRowForm');
    },
    /**
     * @Description 清除验证信息
     * @Date 10:06 2022/10/22
     * @Param
     * @Return
     */
    cleanValidate(formName){
      // 清除表单校验的提示
      if (this.$refs[formName]) {
        // 延时执行
        this.$nextTick(function () {
          this.$refs[formName].cleanValidate();
        })
      };
    },
    /**
     * @Description 清除数据
     * @Date 10:06 2022/10/22
     * @Param
     * @Return
     */
    cleanData(form){
      // 延时执行
      this.$nextTick(() => {
        // 传感器id
        form.sensorId = '';
        // row 下标
        form.rowIndex = -1;
        // 传感器名称
        form.sensorName = '';
        // 传感器编号
        form.deviceNo = '';
        // 最小阈值
        form.minThreshold = '';
        // 最大阈值
        form.maxThreshold = '';
        // 最小量程
        // form.gasMinRange = '';
        // 最大量程
        // form.gasMaxRange = '';
        // 传感器类型id
        form.sensorTypeId = '';
        // 传感器类型
        form.sensorType = '';
      });// 延时执行
    },

  }
}
</script>

/* CSS */
<style scoped>
/deep/ .el-dialog {
  width: 1200px;
  max-width: 90%;
}
/deep/ .el-dialog__body {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components_pages/gas/GasInfoDialog.vue